import BaseDialogActions from '@material-ui/core/DialogActions'

const DialogActions = BaseDialogActions

export default DialogActions
